export enum NavigationUpdatesView {
  LIST = 'LIST',
  SETTINGS = 'SETTINGS',
}
